import { atom } from "recoil"
export const answerModeData = atom({
	key: "answerMode",
	default: false,
})
